import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { Link } from "react-router-dom";
import EduPagination from "../edu-pagination/edu-pagination";

export default function EduReportMgmt() {
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [reportMgmtList, setReportMgmtList] = useState([]);
  const [collegeList, setCollegeList] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState("");
  const [startdate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Get login user for CSV download and permissions
  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }

  // Check if user is college cleaning admin manager
  const isCollegeCleaningAdmin =
    JSON.parse(localStorage.getItem("cleaning_type")) === "College Cleaning";

  let ReportMgmtList = async () => {
    try {
      let response = await axios(
        `${baseUrl}/report_list/?page=${pageNumber}&campus=${selectedCollege}&start_date=${startdate}&end_date=${endDate}`,
        {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );
      if (response?.status === 200 || response?.data?.code === 200) {
        if (Boolean(response?.data?.data)) {
          const extra = response?.data?.extra || {};
          setTotalCount(extra?.count || 0);
          setTotalPages(extra?.total || 1);
          setPageSize(extra?.page_size || 10);
          setReportMgmtList(response?.data?.data);
        } else {
          setReportMgmtList([]);
          setTotalCount(0);
          setTotalPages(1);
        }
      }
    } catch (error) {
      console.error("Error fetching education reports:", error?.response?.data);
      setReportMgmtList([]);
      setTotalCount(0);
      setTotalPages(1);
    }
  };

  let CollegeList = async () => {
    try {
      let response = await axios(`${baseUrl}/get_campus/`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setCollegeList(response?.data?.data || []);
      }
    } catch (error) {
      setCollegeList([]);
    }
  };

  let filterByCollegeHandler = async (e) => {
    setSelectedCollege(e.target.value);
    setPageNumber(1);
    setForceUpdate(!forceUpdate);
  };

  // Delete report function
  const deleteReport = async (id) => {
    try {
      const response = await axios(`${baseUrl}/report_delete/${id}/`, {
        method: "DELETE",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });

      if (response?.status === 200) {
        // Refresh the list after successful deletion
        setForceUpdate(!forceUpdate);
        // You can add a toast notification here if needed
      }
    } catch (error) {
      console.error("Error deleting report:", error);
      // You can add error toast notification here if needed
    }
  };

  // Function to determine cleaning type color for a row
  const getCleaningTypeColor = (row) => {
    if (!row) return "";
    const conditions = [
      row.is_window_close === false,
      row.is_light_off === false,
      row.is_door_lock === false,
      row.all_comsumables === false,
    ];
    const falseCount = conditions.filter(Boolean).length;
    if (falseCount === 0) return "green";
    if (falseCount > 1) return "violet";
    if (row.is_window_close === false) return "yellow";
    if (row.is_light_off === false) return "red";
    if (row.is_door_lock === false) return "orange";
    if (row.all_comsumables === false) return "blue";
    return "";
  };

  useEffect(() => {
    (async function () {
      try {
        await ReportMgmtList();
      } catch (error) {
        console.error("Error :", error.response?.data);
        setReportMgmtList([]);
        setTotalCount(0);
      }
    })();
  }, [forceUpdate, pageNumber, selectedCollege, startdate, endDate]);

  useEffect(() => {
    try {
      (async function () {
        if (collegeList?.length === 0) {
          await CollegeList();
        }
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
  }, []);

  return (
    <>
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                Education Report Management
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/education">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Education Report Management
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              {loginUser?.id && (
                <div className="mb-3 d-flex justify-content-start">
                  <Link
                    className="btn btn-primary mb-2 ms-1"
                    to={`${baseUrl}/download_report_excel/${loginUser?.id}/`}
                  >
                    <i className="fa fa-download me-2"></i> Download CSV
                  </Link>
                </div>
              )}
              <div className="bus-filter">
                <div className="row justify-content-end gap-2">
                  <div className="col-lg-4">
                    <select
                      name="college"
                      onChange={filterByCollegeHandler}
                      className="form-select"
                      value={selectedCollege}
                    >
                      <option value="">
                        {selectedCollege === ""
                          ? "Select College"
                          : "Clear Select"}
                      </option>
                      {collegeList?.map((arr) => {
                        return (
                          <option key={arr?.id} value={arr?.id}>
                            {arr.campus_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-4 d-flex gap-2 flex-row">
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Start Date"
                      onChange={(e) => {
                        setStartDate(e.target.value);
                        setPageNumber(1);
                        setForceUpdate(!forceUpdate);
                      }}
                    />
                    <input
                      type="date"
                      className="form-control"
                      placeholder="End Date"
                      onChange={(e) => {
                        setEndDate(e.target.value);
                        setPageNumber(1);
                        setForceUpdate(!forceUpdate);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                {/* Color Coding Legend */}
                <div className="mb-3">
                  <strong>Color Coding:</strong>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginTop: 5,
                    }}
                  >
                    <span
                      style={{
                        background: "yellow",
                        color: "#000",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      Window not closed
                    </span>
                    <span
                      style={{
                        background: "red",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      Light not off
                    </span>
                    <span
                      style={{
                        background: "orange",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      Door not locked
                    </span>
                    <span
                      style={{
                        background: "blue",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      {" "}
                      Not replenished
                    </span>
                    <span
                      style={{
                        background: "violet",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      Multiple issues
                    </span>
                    <span
                      style={{
                        background: "#5D4037",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      REGULAR_CLEANING with lost property
                    </span>
                    <span
                      style={{
                        background: "#7F00FF",
                        color: "#fff",
                        padding: "2px 8px",
                        borderRadius: 4,
                      }}
                    >
                      TERM_CLEANING with issues
                    </span>
                  </div>
                </div>
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th> Date</th>
                      <th>Time</th>
                      <th>Location</th>
                      <th>Cleaner Name</th>
                      {/* <th>College</th> */}
                      <th>College</th>
                      <th>Block</th>
                      <th>Company</th>
                      <th>Work Description</th>
                      <th> Cleaning Type</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <>
                    {reportMgmtList?.length > 0 ? (
                      <tbody>
                        {reportMgmtList.map((arr, i) => {
                          return (
                            <tr key={arr.id}>
                              <td>{++i + pageSize * (pageNumber - 1)}</td>
                              <td>
                                <span>{arr?.date}</span>
                              </td>
                              <td>
                                <span>{arr?.time}</span>
                              </td>
                              <td>
                                <span>{arr?.location}</span>
                              </td>
                              <td>
                                <span>{arr?.name_cleaner}</span>
                              </td>
                              {/* <td>
                                <span>{arr?.college_name}</span>
                              </td> */}
                              <td>
                                <span>{arr?.campus_name}</span>
                              </td>
                              <td>
                                <span>{arr?.block_name}</span>
                              </td>
                              <td>
                                <span>{arr?.company_name}</span>
                              </td>
                              <td>
                                <span>{arr?.desc_of_work}</span>
                              </td>

                              <td
                                style={{
                                  background:
                                    arr?.cleaning_type === "TERM_CLEANING" &&
                                    arr?.issues &&
                                    Array.isArray(arr.issues) &&
                                    arr.issues.length > 0
                                      ? "#7F00FF" // Violet background for TERM_CLEANING with issues
                                      : arr?.cleaning_type === "TERM_CLEANING"
                                      ? undefined // No background for TERM_CLEANING without issues
                                      : arr?.cleaning_type ===
                                          "REGULAR_CLEANING" &&
                                        arr?.issues &&
                                        Array.isArray(arr.issues) &&
                                        arr.issues.length > 0
                                      ? "#5D4037" // Dark brown for REGULAR_CLEANING with issues
                                      : getCleaningTypeColor(arr) === "green"
                                      ? "#fff" // White background when all issues resolved
                                      : getCleaningTypeColor(arr),
                                  color:
                                    arr?.cleaning_type === "TERM_CLEANING" &&
                                    arr?.issues &&
                                    Array.isArray(arr.issues) &&
                                    arr.issues.length > 0
                                      ? "#fff" // White text for violet background
                                      : arr?.cleaning_type === "TERM_CLEANING"
                                      ? undefined // No color change for TERM_CLEANING without issues
                                      : arr?.cleaning_type ===
                                          "REGULAR_CLEANING" &&
                                        arr?.issues &&
                                        Array.isArray(arr.issues) &&
                                        arr.issues.length > 0
                                      ? "#fff" // White text for dark brown background
                                      : getCleaningTypeColor(arr) === "green"
                                      ? "#000" // Dark text when all issues resolved
                                      : ["yellow", "orange", "blue"].includes(
                                          getCleaningTypeColor(arr)
                                        )
                                      ? "#000"
                                      : "#fff",
                                  padding: "8px 12px",
                                  borderRadius: "4px",
                                  fontWeight: "bold",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  height: "100%",
                                  border: "none",
                                }}
                              >
                                {arr?.cleaning_type}
                              </td>
                              <td>
                                <Link
                                  className="btn btn-outline-info btn-sm rounded-circle btn-sm mx-1"
                                  to={`/education/report-view/${arr.id}`}
                                >
                                  <i className="fa fa-eye" />
                                </Link>

                                {isCollegeCleaningAdmin && (
                                  <button
                                    className="btn btn-outline-danger btn-sm rounded-circle btn-sm mx-1"
                                    onClick={() => deleteReport(arr.id)}
                                    title="Delete Report"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan="4">
                            <span>No data available</span>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </>
                </table>
                <EduPagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={totalPages}
                  setPageLimit={() => {}}
                  totalCount={totalCount}
                  isTotalPages={true}
                  pageSize={pageSize} // Add this prop
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
